import { BreakdownServiceAuthorType, SelfServiceType } from 'modules/selfServices/types/SelfService';
import { ConnectionTypeLogin } from 'modules/dealers/types/ContextResponse';
import { LoginData } from 'modules/auth/types/InitialState';

export enum ChannelEnum {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
}

export enum WhatsAppStatusEnum {
  REACHABLE = 'REACHABLE',
  UNREACHABLE = 'UNREACHABLE',
}

export enum MfaScopeEnum {
  REOPEN = 'REOPEN',
}

export interface LoginRequest {
  registration: string;
  locationId?: number;
}

export interface GetMFAConnectionRequest {
  registration: string;
  type?: SelfServiceType;
  brandId?: string;
  dealerId?: string;
  phoneNumber?: string;
  scope?: MfaScopeEnum;
}

export type LoginParams = LoginData & {
  type?: SelfServiceType;
  connectionTypes: ConnectionTypeLogin[];
};

export interface SendMFACodeRequest {
  connectionId: string;
  selfServiceId: string;
  channel?: ChannelEnum;
}

export interface SendQrCodeRequest {
  qrCode: string;
  type: SelfServiceType;
}

export interface LoginMFARequest {
  connectionId: string;
  selfServiceId: string;
  code: string;
  breakdownServiceAuthorType?: BreakdownServiceAuthorType;
}

export interface SendAdminCodeRequest {
  kioskId: string;
  pinCode: string;
  qrCodeToken: string;

}

export interface CheckQRCodeTokenRequest {
  qrCodeToken: string;
  kioskId: string;
}
